import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './form.css';
function ImportantAsterisk() {
    return _jsx("span", { className: styles.importantAsterisk, children: "*" });
}
export function Required(label) {
    return (_jsxs(_Fragment, { children: [label, " ", _jsx(ImportantAsterisk, {})] }));
}
export default ImportantAsterisk;
